import React from 'react';
import { useTranslation } from 'react-i18next';

import { View } from '@actual-app/components/view';

import { CabecalhoGrupo } from '#components/finapp/menu/CabecalhoGrupo';
import { MEU_DINHEIRO, MEU_MES } from '#components/finapp/menu/destinos';
import { ItemDoMenu } from '#components/finapp/menu/ItemDoMenu';

/**
 * O menu principal: 5 itens em 2 grupos, em português.
 *
 * ⭐ Antes eram 12 itens, 7 deles em inglês (Budget, Reports, Schedules,
 * Payees, Rules, Bank Sync, Tags). Elas não sumiram do app — foram para
 * **Ajustes** com nomes que dizem o que fazem (ver `finapp/AtalhosAjustes.tsx`),
 * e as rotas continuam todas registradas em `FinancesApp.tsx`. Tirar do menu
 * não tira do app: é o que mantém o código do upstream intocado.
 *
 * ⚠️ Nenhum item do menu tem contador — Pendências (o único que tinha) saiu
 * em 22/09/2026 (ver `finapp/telasOcultas.ts`). A prop `contador` de
 * `ItemDoMenu` continua existindo, só não tem mais quem a alimente daqui.
 */
export function PrimaryButtons() {
  const { t } = useTranslation();

  return (
    <View data-testid="sidebar-primary-buttons" style={{ flexShrink: 0 }}>
      <CabecalhoGrupo titulo={t('Meu mês')} primeiro />
      {MEU_MES.map(({ rotulo, rota, Icon }) => (
        <ItemDoMenu key={rota} title={t(rotulo)} Icon={Icon} to={rota} />
      ))}

      <CabecalhoGrupo titulo={t('Meu dinheiro')} />
      {MEU_DINHEIRO.map(({ rotulo, rota, Icon }) => (
        <ItemDoMenu key={rota} title={t(rotulo)} Icon={Icon} to={rota} />
      ))}
    </View>
  );
}
